import React, { Component } from "react";
import { LinkContainer } from "react-router-bootstrap";
import Feature from './content/Feature.js';
import { Button } from "react-bootstrap";


class DownloadLists extends Component {

	render() {
		return (
	      	<Feature borderless={this.props.borderless} shade={this.props.shade} h3="Download" h4="Ready-made lists" h5="Alternatively, choose from our most often downloaded lists">
	      		<LinkContainer to="/lists">
	      			<Button>See the lists</Button>
	      		</LinkContainer>      		
	      	</Feature>
      	);
	}
}

export default DownloadLists;


// WEBPACK FOOTER //
// ./src/DownloadLists.js